const epcRoutes = [
  {
    path: '/oepc',
    name: 'oepc',
    redirect: {
      name: 'oepc.auto-redirect',
    },
    children: [
      {
        path: 'referral',
        name: 'oepc.referral',
        meta: {
          public: true,
        },
        redirect: {
          name: 'referral',
          params: {
            type: 'oepc',
          },
        },
      },
      {
        name: 'oepc.auto-redirect',
        path: 'redirect',
        component: () => import('./components/OepcRedirect.vue'),
      },
      {
        name: 'oepc.request',
        path: ':action?',
        component: () => import('./OEPCFlow.vue'),
      },
    ],
  },
]

export const oepcSteps = {
  WELCOME: 'welcome',
  BUILDING_TYPE: 'building-type',
  ADDRESS: 'address',
  OEPC_EXTRA_INFO: 'oepc-extra-info',
  CUSTOM_QUOTE: 'custom-quote',
  APPOINTMENT_PENDING: 'appointment-pending',
  BORROWER_DETAILS: 'borrower-details',
  CONFIRM_APPOINTMENT: 'confirm-appointment',
  CONFIRM_PAYMENT: 'confirm-payment',
  PAYMENT_PENDING: 'payment-pending',
  BOOKING_COMPLETE: 'booking-complete',
  DOCUMENT_UPLOAD: 'document-upload',
}

export default epcRoutes
